import { AnimatePresence, motion } from "motion/react";
import { NotificationType } from "@/domains/notification/constants/notificationType";
import { NotificationStatus } from "@/domains/notification/constants/status";
import isPlayerLevelNotification from "@/domains/notification/helpers/isPlayerLevelNotification";
import isProfessionNotification from "@/domains/notification/helpers/isProfessionNotification";
import isQuestErrorNotification from "@/domains/notification/helpers/isQuestErrorNotification";
import isQuestSuccessNotification from "@/domains/notification/helpers/isQuestSuccessNotification";
import isSkillNotification from "@/domains/notification/helpers/isSkillNotification";
import useShowNotification from "@/domains/notification/hooks/useShowNotification";
import AchievementGrid from "@/domains/notification/components/NotificationGrid";
import AchievementPlayerLevel from "@/domains/notification/components/NotificationPlayerLevel";
import AchievementProfession from "@/domains/notification/components/NotificationProfession";
import AchievementQuestError from "@/domains/notification/components/NotificationQuestError";
import AchievementQuestSuccess from "@/domains/notification/components/NotificationQuestSuccess";
import AchievementSkill from "@/domains/notification/components/NotificationSkill";

export default function NotificationContainer() {
  const { notification } = useShowNotification();

  return (
    <AnimatePresence>
      {notification ? (
        <motion.div className="fixed left-[50%] -translate-x-[50%]">
          <div className="relative">
            {/* NotificationType.QuestSuccess */}
            {notification.type === NotificationType.QuestSuccess &&
              isQuestSuccessNotification(notification.state) && (
                <>
                  <AchievementQuestSuccess
                    className="absolute left-[50%] -translate-x-[50%]"
                    {...notification.state}
                  />
                  <AchievementGrid
                    className="absolute left-[50%] -translate-x-[50%]"
                    status={NotificationStatus.Success}
                  />
                </>
              )}

            {/* NotificationType.QuestError */}
            {notification.type === NotificationType.QuestError &&
              isQuestErrorNotification(notification.state) && (
                <>
                  <AchievementQuestError
                    className="absolute left-[50%] -translate-x-[50%]"
                    {...notification.state}
                  />
                  <AchievementGrid
                    className="absolute left-[50%] -translate-x-[50%]"
                    status={NotificationStatus.Error}
                  />
                </>
              )}

            {/* NotificationType.PlayerLevel */}
            {notification.type === NotificationType.PlayerLevel &&
              isPlayerLevelNotification(notification.state) && (
                <>
                  <AchievementPlayerLevel
                    className="absolute left-[50%] -translate-x-[50%]"
                    {...notification.state}
                  />
                  <AchievementGrid
                    className="absolute left-[50%] -translate-x-[50%]"
                    status={
                      notification.state.increase
                        ? NotificationStatus.Success
                        : NotificationStatus.Error
                    }
                  />
                </>
              )}

            {/* NotificationType.Skill */}
            {notification.type === NotificationType.Skill &&
              isSkillNotification(notification.state) && (
                <>
                  <AchievementSkill
                    className="absolute left-[50%] -translate-x-[50%]"
                    {...notification.state}
                  />
                  <AchievementGrid
                    className="absolute left-[50%] -translate-x-[50%]"
                    status={NotificationStatus.Inherit}
                  />
                </>
              )}

            {/* NotificationType.Profession */}
            {notification.type === NotificationType.Profession &&
              isProfessionNotification(notification.state) && (
                <>
                  <AchievementProfession
                    className="absolute left-[50%] -translate-x-[50%]"
                    {...notification.state}
                  />
                  <AchievementGrid
                    className="absolute left-[50%] -translate-x-[50%]"
                    status={NotificationStatus.Inherit}
                  />
                </>
              )}
          </div>
        </motion.div>
      ) : null}
    </AnimatePresence>
  );
}
